/* eslint-disable comma-dangle */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState, useEffect } from 'react';
import { Button, MenuItem } from '@material-ui/core';
import { toast } from 'react-toastify';
// @ts-ignore
import ReactDataGrid from 'react-data-grid';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
// @ts-ignore
// @ts-ignore
import { ExcelRenderer } from 'react-excel-renderer';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ContainerComponent from '../../components/container';
import { Cards, Footer, ColumnForm } from './styles';

import axios from '../../services/axiosServicesAgendamentos';
import LoadingCommon from '../../components/LoadingCommon';

const Buffer = () => {
  const [column, setColumn] = useState<Array<any>>([]);
  const [row, setRow] = useState<Array<any>>([]);
  const [line, setLine] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fileBase64, setFileBase64] = useState<unknown>('');
  const [loadingSend, setLoadingSend] = useState(false);
  const [polepositionSelected, SetPoleposition] = useState<any | undefined>(
    undefined
  );
  const [data, setPickerData] = useState<Array<any>>([]);

  const defaultColumnProperties = {
    width: 160,
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await axios.get(
        'admin/pole-position/v1/pole-positions-validos'
      );
      setPickerData(response?.data?.data);
    } catch (error) {
      toast.error('Atenção, não foi possível carregar os polepositions!');
    }
  };

  const fileHandler = async (event: any) => {
    if (!event.target.files[0]) {
      return;
    }

    const fileObj = event.target.files[0];
    setLoading(true);
    setRow([]);
    setColumn([]);

    setTimeout(() => {
      ExcelRenderer(fileObj, async (err: any, resp: any) => {
        if (err) {
          setLoading(false);
          toast.error('Não foi possível carregar o arquivo.');
        } else {
          setFileBase64(fileObj);

          const dataToColumn = resp.cols.map((c: any) => ({
            ...c,
            ...defaultColumnProperties,
          }));
          setColumn(
            dataToColumn.map((item: any) => {
              if (item.key === 0) {
                item.width = 200;
                return item;
              }
              if (item.key === 1) {
                item.width = 150;
                return item;
              }
              if (item.key === 2) {
                item.width = 120;
                return item;
              }
              if (item.key === 3 || item.key === 4) {
                item.width = 160;
                return item;
              }
              if (item.key === 6 || item.key === 7) {
                item.width = 120;
                return item;
              }
              if (item.key === 9 || item.key === 10) {
                item.width = 150;
                return item;
              }
              if (item.key === 12) {
                item.width = 100;
                return item;
              }
              return item;
            })
          );
          setRow(resp.rows);
          setLine(resp.rows.length);
          setLoading(false);
        }
      });
    }, 1000);
  };

  const onGridRowsUpdated = ({ fromRow, toRow, updated }: any) => {
    const rows = row.slice();
    for (let i = fromRow; i <= toRow; i++) {
      rows[i] = { ...rows[i], ...updated };
    }
    setRow(rows);
    return { rows };
  };

  const save = async () => {
    try {
      const fileData = new FormData();
      if (polepositionSelected?.nome === undefined) {
        toast.error('Selecione um Poleposition.');
        return;
      }

      setLoadingSend(true);
      // @ts-ignore
      fileData.append('file', fileBase64);
      const header = {
        'Content-Type': 'multipart/form-data',
      };
      await axios.post(
        `admin/pole-position/pontuacoes-corretores/v1/upload-pontuacao-corretor?idPolePosition=${polepositionSelected?.idPolePosition}`,
        fileData,
        {
          headers: header,
        }
      );

      setRow([]);
      setLine(0);
      setColumn([]);
      setLoadingSend(false);
      SetPoleposition(null);
      toast.success('Arquivo enviado com sucesso!');
    } catch (error) {
      setLoadingSend(false);
      toast.error('Erro ao enviar o arquivo, tente novamente!');
    }
  };

  const RowRenderer = ({
    renderBaseRow,
    ...props
  }: {
    renderBaseRow: any;
    props: any;
  }) => (
    <div
      style={{
        color: '#333333',
        fontFamily: 'Graphik-Regular',
        fontSize: 13,
        display: 'flex',
        flex: 1,
      }}
    >
      {renderBaseRow(props)}
    </div>
  );

  const handleChange = (event: any) => {
    SetPoleposition(event.target.value);
  };

  return (
    <ContainerComponent component="div" maxWidth="xl">
      <Cards>
        <FormControl
          style={{
            marginLeft: 20,
            paddingRight: 40,
            marginTop: 20,
            width: '100%',
          }}
        >
          <InputLabel id="demo-simple-select-label">
            Selecione um poleposisiton
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={polepositionSelected?.nome}
            onChange={handleChange}
          >
            {data.map((item) => (
              <MenuItem value={item}>{item?.nome}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <ColumnForm>
          {loading ? (
            <small
              style={{
                fontFamily: 'Graphik-Regular',
                marginTop: 40,
                fontSize: 14,
              }}
            >
              Aguarde, estamos processando o arquivo...
            </small>
          ) : (
            <ReactDataGrid
              columns={column}
              // @ts-ignore
              rowGetter={(i: any) => row[i]}
              rowsCount={line}
              minHeight={500}
              onGridRowsUpdated={onGridRowsUpdated}
              enableCellSelect
              rowRenderer={RowRenderer}
              enableCellAutoFocus={false}
            />
          )}
        </ColumnForm>
        {!loading && (
          <Footer>
            <label htmlFor="contained-button-file">
              <Button
                disabled={loadingSend}
                variant="contained"
                color="default"
                style={{ marginRight: 20, fontSize: 12 }}
                startIcon={<CloudUploadIcon />}
                component="span"
              >
                Selecionar arquivo
              </Button>
            </label>
            <input
              id="contained-button-file"
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              onChange={fileHandler.bind(this)}
              style={{ display: 'none' }}
            />
            {loadingSend ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 80,
                  width: 80,
                  marginLeft: 20,
                }}
              >
                <LoadingCommon />
              </div>
            ) : (
              <Button
                disabled={!(column.length > 0 && row.length > 0)}
                variant="contained"
                onClick={() => save()}
                style={{
                  marginRight: 20,
                  backgroundColor: '#333333',
                  color: 'white',
                  fontSize: 12,
                }}
                component="span"
              >
                Salvar
              </Button>
            )}
          </Footer>
        )}
      </Cards>
    </ContainerComponent>
  );
};
export default Buffer;
